module.exports = ".row{\r\n    padding:20px 0px 0px;\r\n}\r\n\r\n/* .row:nth-child(odd){\r\n    background: #ffffff;\r\n}\r\ntd{\r\n    border: 1px solid #ffffff;\r\n} */"


//////////////////
// WEBPACK FOOTER
// ./src/app/applicant/applicationinstallmentpay/applicationinstallmentpay.component.css
// module id = ./src/app/applicant/applicationinstallmentpay/applicationinstallmentpay.component.css
// module chunks = main